export default __webpack_public_path__ + "static/media/colors.ebc5e812.svg";